import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, Heading, VStack, HStack, Icon, Text } from '@gluestack-ui/themed';
import { Calendar } from 'lucide-react-native';

const EventTaskSidebar = ({ task, children, ...props }) => {
  const { t } = useTranslation();

  if (!task) return null;

  return (
    <Card testID="event-task-sidebar" {...props}>
      <VStack space="lg">
        <HStack alignItems="center" space="sm">
          <Icon as={Calendar} size="md" color="$textLight600" />
          <Heading size="lg">{t('student.module.task-sidebar.eventTitle')}</Heading>
        </HStack>
        {children}
      </VStack>
    </Card>
  );
};

export default EventTaskSidebar;
